export const CATEGORIE_UNITAIRE = 'Unitaire';
export const CATEGORIE_REGROUPEMENT = 'Regroupement';
export const CATEGORIE_LOCATION = 'Location';
export const CATEGORIE_DIVERS = 'Divers';
export const CATEGORIE_LIBRE = 'Libre';
export const CATEGORIE_REGROUPEMENT_NUMERIQUE = 'RegroupementNumerique';
export const CATEGORIE_REGROUPEMENT_LC = 'RegroupementLc';
export const CATEGORIE_ECRAN_NUMERIQUE = 'EcranNumerique';


export const RESEAU_TEMPO = 'Tempo';
export const RESEAU_LC = 'Lc';

export const TYPE_EDITION_RESEAU = 'ProduitReseau';

export const AFFECTATION_RESEAU = 'Reseau';
export const AFFECTATION_LC = 'Commande';



// WEBPACK FOOTER //
// ./src/configuration/produitConf.js